import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IStyleProps } from "./interfaces";

export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: 520px;
    ${p => p.isEaster && css`
        margin-top: 105px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 66px;
        height: calc(100% - 60px - 115px - 152px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 270px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 54px;
    left: 4px;
    right: -6px;
    bottom: 165px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${105 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${223 - padding}px;
    z-index: -1;
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: -10px;
    left: 0;
    pointer-events: none;

    img {
        width: 398px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    bottom: -30px;
    right: 0;
    pointer-events: none;
    img {
        width: 429px;
    }
`;

const btnDimension = 80;
const btnDimensionLow = 60;

export const SoundButton = styled.button<IStyleProps>`
    width: ${p => (p.isLow ? btnDimensionLow : btnDimension)}px;
    height: ${p => (p.isLow ? btnDimensionLow : btnDimension)}px;
    border-radius: ${p => (p.isLow ? btnDimensionLow : btnDimension) / 2}px;
    background: ${p => (p.isActive ? p.theme.c.boost : p.theme.c.snowOnActive)};
    border: 2px solid ${p => (p.isActive ? (p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.black) : p.theme.c.pale)};
    outline: none;
    cursor: pointer;
    position: absolute;
    left: ${p => (p.isLow ? 400 : 32)}px;
    bottom: ${p => (p.isLow ? 200 : 32)}px;

    display: flex;
    align-items: center;
    justify-content: center;

    .i-sound,
    .i-soundOff {
        font-size: ${p => (p.isLow ? btnDimensionLow : btnDimension) * 0.8}px;
        color: ${p => (p.isActive ? p.theme.c.snowOnActive : p.theme.c.pale)};
    }
`;
